import React, { ReactNode } from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { Span } from '../../../../../../wag-react/core-components/span';
import { BoxProps } from '../../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
import { QuestionFilledIcon } from '../../../../../../wag-react/next-components/icons';
export type BenefitAddOnProps = {
  description: ReactNode;
  name: string;
  onHelpIconClick: (name: string, description: ReactNode) => void;
  price: number;
} & BoxProps;
export const BenefitAddOn = ({
  description,
  name,
  onHelpIconClick,
  price,
  ...rest
}: BenefitAddOnProps) => <Flex alignItems="center" border="2px solid #e5e5e5" borderRadius="8px" cursor="pointer" justifyContent="space-between" px={['12px', null, '28px']} onClick={() => {
  onHelpIconClick(name, description);
}} {...rest} data-sentry-element="Flex" data-sentry-component="BenefitAddOn" data-sentry-source-file="index.tsx">
    <Typography fontFamily="muliBold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      {name}
    </Typography>

    <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Typography color="#4669B2" fontFamily="muliBold" fontSize="20px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {`$${price}`}
      </Typography>

      <Span color="wagGray" ml="4px" data-sentry-element="Span" data-sentry-source-file="index.tsx">
        /mo
      </Span>

      <QuestionFilledIcon color="#d8d8d8" cursor="pointer" height="22px" ml={['8px', null, '20px']} width="22px" data-sentry-element="QuestionFilledIcon" data-sentry-source-file="index.tsx" />
    </Flex>
  </Flex>;